import { useRef, useState } from 'react'
import PropTypes from 'prop-types'

import Icon from '../Icons'
import { useSnackbar } from '../../helpers/hooks/useSnackbar'

const ImagesUpload = ({ pickImages, limit, isDisabled }) => {
  const inputRef = useRef()
  const [fileInputValue, setFileValue] = useState([])
  const { displaySnackbar } = useSnackbar()

  const sizeFileLimit = 2000000

  const onChange = (event) => {
    const files = []

    if (event.target.files) {
      const filesCount = event.target.files.length > limit ? limit : event.target.files.length

      for (let i = 0; i < filesCount; i++) {
        files.push(event.target.files[i])
      }
    }

    const oversizedFile = files.find((file) => file.size > sizeFileLimit)

    if (oversizedFile) {
      displaySnackbar('One of the selected images exceeds the size allowed.', true)
    } else {
      const filtered = files.filter((file) => file.size <= sizeFileLimit)
      pickImages(filtered)
    }
    setFileValue([])
  }

  const onUploadClick = () => {
    if (inputRef.current) {
      inputRef.current.click()
    }
  }

  return (
    <div style={{ pointerEvents: isDisabled ? 'none' : 'auto' }}>
      <input
        style={{ display: 'none' }}
        ref={inputRef}
        multiple
        value={fileInputValue}
        type="file"
        onChange={onChange}
        accept=".jpg,.jpeg,.png,.bmp"
      />
      <div onClick={onUploadClick} style={{ display: 'flex', alignItems: 'center' }}>
        <Icon icon="addProduct" viewBox="0 0 20 20" fill={isDisabled ? '#b9b9b9' : ''} />
      </div>
    </div>
  )
}

ImagesUpload.propTypes = {
  pickImages: PropTypes.func,
  limit: PropTypes.number,
  isDisabled: PropTypes.bool,
}

export default ImagesUpload
